import IncidentPage from "@/app/(app)/(crew)/supervising/[shift]/incident";

export default IncidentPage;
